import { getUniqueArray } from "@citrine/utils/helpers";

interface ChemicalFeatureAlias {
  standard: string[];
  extended: string[];
}
export const ELECTRONIC_CHEMICAL_FEATURES: ChemicalFeatureAlias = {
  standard: [
    "Elemental atomic volume", // Also in PHYSICAL_CHEMICAL_FEATURES.standard
    "Pauling electronegativity",
    "Number of d valence electrons",
    "Number of unfilled f valence electrons",
    "Number of f valence electrons",
    "Number of unfilled p valence electrons",
    "Number of p valence electrons",
    "Number of unfilled s valence electrons",
    "Number of s valence electrons",
    "Total number of unfilled valence electrons",
    "Total number of valence electrons",
    "Elemental work function",
    "Elemental polarizability",
    "Radius of d orbitals",
    "Radius of s orbitals",
    "Radius of p orbitals",
    "Elemental magnetic moment",
    "Elemental electron density",
    "Ionization Affinity Ratio",
    "Ratio of Electron Affinity to Electronegativity",
    "Miracle Ratio",
    "Mulliken electronegativity",
    "Zunger Pseudopotential radius ratio",
    "Non-dimensional band gap",
    "Conduction ionization energy",
    "Valence electron density",
    "Non-dimensional work function",
    "Maximum electronegativity difference",
    "Elemental crystal structure (space group)", // Also in PHYSICAL_CHEMICAL_FEATURES.standard
    "DFT energy density", // Also in PHYSICAL_CHEMICAL_FEATURES.standard
    "Maximum radius difference", // Also in PHYSICAL_CHEMICAL_FEATURES.standard
    "Maximum radius ratio", // Also in PHYSICAL_CHEMICAL_FEATURES.standard
    "Min atomic radius plus max electronegativity difference", // Also in PHYSICAL_CHEMICAL_FEATURES.standard
  ],
  extended: [
    "AtomicVolume", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
    "CovalentRadius", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
    "GSestBCClatcnt", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
    "GSvolume_pa", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
    "MiracleRadius", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
    "DipolePolarizability",
    "ElectronAffinity",
    "FirstIonizationEnergy",
    "GSbandgap",
    "GSenergy_pa",
    "NdUnfilled",
    "ZungerPP-r_pi",
    "ValenceZeff", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
  ],
};

export const PERIODIC_CHEMICAL_FEATURES: ChemicalFeatureAlias = {
  standard: [
    "Mendeleev number",
    "Row in periodic table",
    "Minimum weight fraction",
    "Maximum weight fraction",
  ],
  extended: [
    "Number",
    "IsAlkali",
    "IsDBlock",
    "IsFBlock",
    "IsMetal",
    "IsNonmetal",
    "Column in periodic table",
    "AtomicWeight", // Also in PHYSICAL_CHEMICAL_FEATURES.extended
  ],
};

export const PHYSICAL_CHEMICAL_FEATURES: ChemicalFeatureAlias = {
  standard: [
    "Elemental atomic volume", // Also in ELECTRONIC_CHEMICAL_FEATURES.standard
    "Elemental bulk modulus",
    "Elemental density",
    "Elemental melting temperature",
    "Packing density",
    "Liquid range",
    "Non-dimensional liquid range",
    "Liquid ratio",
    "Elastic Poisson Ratio",
    "Interatomic distance",
    "Trouton's Ratio",
    "DFT volume ratio",
    "Modulii sum",
    "BCC Efficiency",
    "Non-dimensional heat of fusion",
    "Shear Modulus Melting Temp Product",
    "Formula weight",
    "Elemental crystal structure (space group)", // Also in ELECTRONIC_CHEMICAL_FEATURES.standard
    "DFT energy density", // Also in ELECTRONIC_CHEMICAL_FEATURES.standard
    "Maximum radius difference", // Also in ELECTRONIC_CHEMICAL_FEATURES.standard
    "Maximum radius ratio", // Also in ELECTRONIC_CHEMICAL_FEATURES.standard
    "Min atomic radius plus max electronegativity difference", // Also in ELECTRONIC_CHEMICAL_FEATURES.standard
  ],
  extended: [
    "AtomicVolume", // Also in ELECTRONIC_CHEMICAL_FEATURES.extended
    "CovalentRadius", // Also in ELECTRONIC_CHEMICAL_FEATURES.extended
    "GSestBCClatcnt", // Also in ELECTRONIC_CHEMICAL_FEATURES.extended
    "GSvolume_pa", // Also in ELECTRONIC_CHEMICAL_FEATURES.extended
    "MiracleRadius", // Also in ELECTRONIC_CHEMICAL_FEATURES.extended
    "BoilingT",
    "FusionEnthalpy",
    "HeatCapacityMass",
    "HeatCapacityMolar",
    "HeatFusion",
    "ShearModulus",
    "AtomicWeight", // Also in PERIOD_CHEMICAL_FEATURES.extended
    "ValenceZeff", // Also in ELECTRONIC_CHEMICAL_FEATURES.extended
  ],
};

export const NO_ALIAS_EXTENDED_CHEMICAL_FEATURES = [
  "Number of elements",
  "Minimum atomic fraction",
  "Maximum atomic fraction",
];

export const STANDARD_CHEMICAL_FEATURES = getUniqueArray([
  ...ELECTRONIC_CHEMICAL_FEATURES.standard,
  ...PERIODIC_CHEMICAL_FEATURES.standard,
  ...PHYSICAL_CHEMICAL_FEATURES.standard,
]).sort();

export const EXTENDED_CHEMICAL_FEATURES = getUniqueArray([
  ...ELECTRONIC_CHEMICAL_FEATURES.extended,
  ...PERIODIC_CHEMICAL_FEATURES.extended,
  ...PHYSICAL_CHEMICAL_FEATURES.extended,
  ...NO_ALIAS_EXTENDED_CHEMICAL_FEATURES,
]).sort();

export function isStandardChemicalFeature(feature: string) {
  return STANDARD_CHEMICAL_FEATURES.includes(feature);
}

export function isExtendedChemicalFeature(feature: string) {
  return EXTENDED_CHEMICAL_FEATURES.includes(feature);
}
